module.exports = __webpack_public_path__ + "img/left-hand.123620a0.svg";